import { dataSender } from '../../common/utils/router';
import { transformSearchUserData } from './initData';
import { API_SERVER_URL } from '../../common/utils/utils';
import css from './search-window.module.scss';
import T from '../../common/components/T';
import SingleButton from '../form/form-control-buttons/SingleButton/SingleButton';

export const sendFunction = (
    val,
    sendData,
    setUserTableData,
    userToken,
    setAlertData,
    lang,
    transformSearchData = false,
    userId,
    selectedIds,
    adminPage,
    display_country,
    fastSearch,
    fastSearchData
) => {
    let searchParam = '';
    if (fastSearch) {
        const params = Object.keys(fastSearchData)
            .reduce((acc, key) => {
                if (fastSearchData[key]) {
                    acc.push(`filter[${key}]=${fastSearchData[key]}`);
                }
                return acc;
            }, [])
            .join('&');

        searchParam = `${sendData?.url && sendData?.url.indexOf('?') === -1 ? '?' : '&'}${params}`;
    } else {
        searchParam =
            !!val && val.length
                ? // ? `${sendData?.url.indexOf('?') === -1 ? '?' : '&'}filter[q]=${val}`
                  `${!sendData?.url || sendData?.url.indexOf('?') === -1 ? '?' : '&'}filter[q]=${val}`
                : '';
    }

    const urlData = sendData?.url
        ? `${sendData?.url}${searchParam}`
        : `${API_SERVER_URL}/api/v1/user/partners/${userId || '1'}/descendants?include=marketingProfile${searchParam}`;

    dataSender(
        urlData,
        'GET',
        false,
        (response) => {
            setAlertData(null);
            const resData = response.data;
            if (transformSearchData) {
                setUserTableData(transformSearchData(resData, selectedIds));
            } else {
                setUserTableData(transformSearchUserData(resData, adminPage));
            }
        },
        (data) => {
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData({ type: 'error', cont: data?.false });
            }
        },
        userToken,
        lang,
        false,
        false,
        false,
        !!Number(display_country) ? { 'Display-Country': '1' } : null
    );
};

export const getFormStyles = {
    search: {
        wrapper: css.searchWrapper,
        inner: css.searchInner
    },
    ...['username', 'name'].reduce((acc, key) => {
        acc[key] = {
            wrapper: css.input50
        };
        return acc;
    }, {}),
    ['search-button']: {
        wrapper: css.searchButtonWrapper
    }
};

export const getFormFields = (trans, fastSearch, input, sendFunc, ranks, type) => {
    return fastSearch
        ? [
              {
                  attribute: 'username',
                  title: {
                      body: <T textName='user_id' defaultStr='ID пользователя' />
                  },
                  type: 'input'
              },
              {
                  attribute: 'name',
                  title: {
                      body: <T textName='user_fio' defaultStr='ФИО пользователя' />
                  },
                  type: 'input'
              },
              ...(type == 'matrix'
                  ? [
                        {
                            attribute: 'rank_id',
                            title: {
                                body: <T textName='user_rank' defaultStr='Статус' />
                            },
                            options: ranks.map((i) => ({
                                id: i.id,
                                title: i.name
                            })),
                            type: 'dropdown'
                        }
                    ]
                  : []),
              {
                  type: 'info-field',
                  html: (
                      <SingleButton
                          clickFunc={sendFunc}
                          customButton={{ singleButton: css.searchUserButton }}
                          type='ok'
                          buttonText={<T textName='search' defaultStr='Поиск' />}
                      />
                  ),
                  attribute: 'search-button'
              }
          ]
        : [
              {
                  attribute: 'search',
                  disabled: false,
                  hint: false,
                  name: 'search',
                  placeholder: (
                      <T
                          textName='SearchWindowsearchtitle'
                          page='widget'
                          group='searchWindow'
                          defaultStr='Поиск пользователя'
                          customTranslates={trans}
                          customLoading={!trans}
                      />
                  ),
                  placeholderHidden: false,
                  type: 'input',
                  search: { type: 'onInput' },
                  required: false,
                  info: (
                      <T
                          textName='SearchWindowsearchinfo-v1'
                          page='widget'
                          group='searchWindow'
                          defaultStr='Поиск осуществляется по фамилии, имени, ID, телефону и др. контактам'
                          customTranslates={trans}
                          customLoading={!trans}
                      />
                  ),
                  ...input
              }
          ];
};
